export default __webpack_public_path__ + "static/media/allinfra3.70d5a388.png";